import React, { useState } from "react";
import "./styles.css";

import { useRef } from "react";
import Header from "../../Common/Header";
import Footer from "../../Common/Footer";

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../../Context/Context";
import { use, useContext, useEffect } from "react";
import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
} from "../../Services/ApiCall";
import FeaturedProperty from "../../Common/FeaturedProperties";
import ProjectsComp from "../../Common/Projects";
import NearByProperties from "../../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  BaseUrl,
  apiUrl_dialerp,
  setLogindata,
  setUserdata,
} from "../../Services/Urls";
import FilterParams from "../../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../../Common/SelectDialog ";
import AmenitiesDialog from "../../Common/AmenitiesDialog";
import { decryptOtp, getDisplayPrice } from "../../Services/Helper";
import {
  callApi,
  makeApiRequest,
  callAzureOpenAI,
} from "../../Services/ApiService";

import { toast } from "react-toastify";
import SucessDialog from "../../Common/Dialog/SucessDialog";
import {
  formatIndianAmount,
  removeSpecialCharacters,
} from "../../Services/Helper";

const data = [
  {
    id: "TXN001",
    date: "15 Jan 2024",
    name: "Andheri West Premium Boost",
    amount: "₹2,500",
    status: "Paid",
  },
  {
    id: "TXN002",
    date: "12 Jan 2024",
    name: "Bandra East Apartment Campaign",
    amount: "₹1,500",
    status: "Paid",
  },
  {
    id: "TXN003",
    date: "10 Jan 2024",
    name: "Powai Lake View Boost",
    amount: "₹1,000",
    status: "Paid",
  },
  {
    id: "TXN004",
    date: "8 Jan 2024",
    name: "Goregaon Villa Campaign",
    amount: "₹5,000",
    status: "Paid",
  },
  {
    id: "TXN005",
    date: "5 Jan 2024",
    name: "Malad West Property Boost",
    amount: "₹750",
    status: "Refunded",
  },
  {
    id: "TXN006",
    date: "3 Jan 2024",
    name: "Kandivali East Campaign",
    amount: "₹3,000",
    status: "Paid",
  },
  {
    id: "TXN007",
    date: "1 Jan 2024",
    name: "Borivali West Boost",
    amount: "₹500",
    status: "Pending",
  },
];

export default function BillingPayment() {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,

    coordinates,

    Locality,

    Area,
  } = useContext(ApiContext);
  const navigate = useNavigate();
  const [walletData, setwalletData] = useState(null);
  const [Transactions, setTransactions] = useState([]);
  const [loading, setloading] = useState(false);
  const [totalSpent, setTotalSpent] = useState(0);

  useEffect(() => {
    getwalletdetails();
    getTransactions();
  }, []);

  const getwalletdetails = () => {
    const filter = `{UserID: { $in: [${LoggedInUserID}] }}`;

    getRecords(437, 1, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setwalletData(data?.response?.records[0] || null);
          setloading(false);

        } else {
          setwalletData(null);
          setloading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setloading(false);
      }
    });
  };

  const getTransactions = () => {
    const filter = `{UserID: { $in: [${userData?.UserID}] }}`;
    getRecords(438, 1000, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setTransactions(data?.response?.records || []);
          setloading(false);
          
          if (data?.response?.records?.length > 0) {
            let TotalSpent = 0;

            data?.response?.records?.forEach((element) => {
              TotalSpent += Number(element?.Amount || 0);
            });

            setTotalSpent(Number(TotalSpent.toFixed(2)));
          }
        } else {
          setTransactions([]);
          setloading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setloading(false);
      }
    });
  };

  return (
    <>
      <div className="breadcrumb">
        <span className="light">LandPanda Ads</span>
        <span className="arrow">›</span>
        <span className="bold">Billing</span>
      </div>
      <div className="billpayment">
        <div className="wallet-card">
          <div className="wallet-header">
            <div>
              <p className="label">Available Boost Credits</p>
              <h1>₹{walletData?.Balance}</h1>
              <span className="sub">Ready to use for campaigns</span>
            </div>
            <div className="wallet-icon">
              <i class="ri-wallet-3-line text-xl sm:text-2xl"></i>
            </div>
          </div>

          <div className="wallet-actions">
            <button onClick={() => navigate("/wallet")} className="btn primary">
              + Add Credits
            </button>
            <button
              onClick={() => navigate("/wallet")}
              className="btn secondary"
            >
              ⟳ History
            </button>
          </div>
        </div>

        <div className="stats">
          <div className="stat-box">
            <div className="icon blue">
              <i class="ri-money-rupee-circle-line text-blue-600 text-base sm:text-lg"></i>
            </div>
            <div>
              <p>Total Spent</p>
              <h3>₹{totalSpent}</h3>
            </div>
          </div>
          <div className="stat-box">
            <div className="icon green">
              <i class="ri-check-double-line text-emerald-600 text-base sm:text-lg"></i>
            </div>
            <div>
              <p>Completed Payments</p>
              <h3>{Transactions?.length}</h3>
            </div>
          </div>
          <div className="stat-box">
            <div className="icon orange">
              <i class="ri-time-line text-amber-600 text-base sm:text-lg"></i>
            </div>
            <div>
              <p>Pending Payments</p>
              <h3>0</h3>
            </div>
          </div>
        </div>

        <div className="table-card billingtable">
          <div className="table-header">
            <h3>Transaction History</h3>
            <div className="filters">
              <span className="active">All</span>
              <span>Paid</span>
              <span>Pending</span>
              <span>Refunded</span>
            </div>
          </div>

          <table>
            <thead>
              <tr>
                <th>TRANSACTION ID</th>
                <th>DATE</th>
                <th>CAMPAIGN NAME</th>
                <th>AMOUNT</th>
                <th>STATUS</th>
                {/* <th>INVOICE</th> */}
              </tr>
            </thead>
            <tbody>
              {Transactions?.map((item, i) => (
                <tr key={i}>
                  <td>{item.TransactionID}</td>
                  <td>{item.cDt?.split(" ")[0]}</td>
                  <td>{item.Campaign}</td>
                  <td>{item.Amount}</td>
                  <td>
                    <span className={`status ${"paid"}`}>{"Paid"}</span>
                  </td>
                  {/* <td className="download">
                    <i class="ri-download-2-line text-lg text-green"></i>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
